import { jsx as _jsx } from "react/jsx-runtime";
import { memo, useMemo } from 'react';
import { VehicleDeviceState } from './types';
export const VehicleDeviceStateProvider = memo(function VehicleDeviceStateProvider(props) {
    const { children, silent_mode, service_mode, voltage, auto_ignition } = props;
    const vehicle_device_state = useMemo(() => ({
        silent_mode,
        service_mode,
        auto_ignition,
        voltage,
    }), [silent_mode, service_mode, voltage, auto_ignition]);
    return (_jsx(VehicleDeviceState.Provider, { value: vehicle_device_state, children: children }));
});
